// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__sKcQE","button__mask":"Button_button__mask__39u4N","button__text":"Button_button__text__2GErZ"};